/**
 * Whitelist of NFT collections that are shown on the NFT tab by default.
 *
 * Most of the NFT supply on TON is spam, so everything outside of this list is
 * hidden behind a filter on the NFT tab. Names are comments only, the
 * addresses are the data.
 */

// Telegram gifts minted on TON. They get a "view in Telegram" button on the
// item page, so we need to know which collections they are.
export const TELEGRAM_GIFT_COLLECTIONS = new Set([
    'EQATuUGdvrjLvTWE5ppVFOVCqU2dlCLUnKTsu0n1JYm9la10', // Scared Cats
    'EQBG-g6ahkAUGWpefWbx-D_9sQ8oWbvy6puuq78U2c4NUDFS', // Plush Pepes
    'EQBI07PXew94YQz7GwN72nPNGF6htSTOJkuU4Kx_bjTZv32U', // Swiss Watches
    'EQD9ikZq6xPgKjzmdBG0G0S80RvUJjbwgHrPZXDKc_wsE84w', // Durov’s Caps
    'EQC1gud6QO8NdJjVrqr7qFBMO0oQsktkvzhmIRoMKo8vxiyL', // Toy Bears
    'EQCE80Aln8YfldnQLwWMvOfloLGgmPY0eGDJz9ufG3gRui3D', // Loot Bags
    'EQA4i58iuS9DUYRtUZ97sZo5mnkbiYUBpWXQOe3dEUCcP1W8', // Precious Peaches
    'EQC4XEulxb05Le5gF6esMtDWT5XZ6tlzlMBQGNsqffxpdC5U', // Heart Lockets
    'EQAoJw7BpOcBD3y9voMuEQ-qhS3K4gtM-6EePLxkzk8iSifX', // Snoop Doggs
    'EQACcQpR2fmdeENWdE2YGQWHVxSTyA8Zq4_k7rk_IaxCRXNe', // Vintage Cigars
    'EQAlROpjm1k1mW30r61qRx3lYHsZkTKXVSiaHEIhOlnYA4oy', // Heroic Helmets
    'EQDCPq7QSUvCmq7kBhmDulxVdeFHKFc1wT9MQxnesanl1Hql', // Low Riders
    'EQA72Uevr_MHvzYwSCHJUK-uC6kd-w8kbxzhJ49WIiG-o6CD', // Snoop Cigars
    'EQC6zjid8vJNEWqcXk10XjsdDLRKbcPZzbHusuEW6FokOWIm', // Lol Pops
    'EQAZjuUJmbP-V4Ryowjexh7bIcdNrrojr0WKSpdggB0zbst5', // Nail Bracelets
    'EQCNsmpHqRSY_Dxnyh6P0MMO7zcABf8sVvG0wr245pBzO3B3', // Voodoo Dolls
    'EQDvZ_9Z3tJ9k6eELLtTeuQAz4yOOWyYFZfzqNv2dGJiHvrF', // Westside Signs
    'EQCrGA9slCoksgD-NyRDjtHySKN0Ts8k6hdueJkUkZZdD4_K', // Signet Rings
    'EQBMcfMAZlMUr1W3X8kdEw3fJMUAaWH4-XcmE5R5RfFIY0E2', // Desk Calendars
    'EQDIReleOkTxCD4g_XEm8xj0LYNg6-zMsTGAAwCA-vEbkGBu', // Astral Shards
    'EQBUvskEvmWdp_V6HX-2Tyfp4mFSzMzdg9TaUz6zKVz6Ov3f', // Ice Creams
    'EQDaj18cd61VLZHCHsM7sKbfxBudD3gaSfcN02olVnQ3BCIB', // UFC Strikes
    'EQCWh1lPltyTwCWxCXm4umL5tPZoXR8kTIcT-pd0JqoadLHo', // Diamond Rings
    'EQBSIId7sMmlqN8oBGaMNtUeuaLeSQPUR1ByMwpnfWL3hhZq', // Input Keys
    'EQCZ4-h65iTiWDPRPcLlS63gbcS40YBadEFLA4W-iIWUZld0', // Spring Baskets
    'EQDTro-ogJbS7o-OBD6bt2NysPt7SnGm5zfuRXGB1nE_rbGa', // Kissed Frogs
    'EQDRrfw5pgIC4e6NafUAx52Z9Ym6q1k26xxaXR_qx0LKJJ7D', // Light Swords
    'EQDc08YxzZWtlKAohSybNc3kXAkAPPtHch-jY_E6KMQ3b1mn', // Vice Creams
    'EQBlBJ4n01pmYez5VPd8Wo598s8agbQCyVOjucXKxLDAi9r7', // Chill Flames
    'EQAwnP7dGfE_WO0xiCiulkAXUG1K1bWH1vE1k64T4G-7gruO', // Easter Eggs
    'EQCgaTxb2wA_3Bi8Ec4FFNu8CauoHo0VPpnwxdrhAgOrOXvA', // Swag Bags
    'EQCeTSJOPXP_SSvOjILY-kui4bGHUmsa-U7TXP4DjUANTl4s', // Jolly Chimps
    'EQBIj0uF-qIASqv6qIvcTif2wKSdt4WQc4mcoBywNp5GntuG', // Instant Ramens
    'EQCDBbQYbv3n91TwywBRD9YrJNuNVmbD3Sprpq6hWIDHVu4p', // Sakura Flowers
    'EQDJsN9OJBhKGZoWZWtkEpzkCfIu16Z9UzTWbYjeLpuHdT5f', // Perfume Bottles
    'EQA2RI7XvIs9wJQKrxkTb7YtpeUuaD-p0eT5uBe4bkcGT2bd', // Artisan Bricks
    'EQAXHW9KVYYgDmLaUNcgzNPZ4WKGek97-ldsd0fPUHg4K7SU', // Clover Pins
    'EQCa1I09fE9UoTV6awM6QC9-fkv51hoii24w1tJoFfigG_ax', // Party Sparklers
    'EQA0JBiVCjdgqkiHiYmIgTUBbZI6mNbnSymqf0HFC7FhxpuT', // Cupid Charms
    'EQDIruSTyxvq60gUH8j2kkj3qzoBrBaJy9WkKbeNNRasWe4j', // Stellar Rockets
    'EQAqtF5tZIgNZal80ChzdPMvZCN8OEbJCVJPn_0xNPghQJPW', // Gem Signets
    'EQAIwEMO6wB8Iby8Va0EQGPkDWcVc6uUmMOfXmEyqZmM93sl', // Rare Birds
    'EQBCe75G0AhjqC64B7H_BHP0wgfONX_x98rszmsEwndDVAjG', // Ginger Cookies
    'EQBayCY2wZwrVBExNfLL8v9K0mHNmrQTntZldgpYiRwB_QKK', // Neko Helmets
    'EQDsNmzs1xb4df4U439Oo91bp-s2UDP_DxfL-E0Yhf4UULLu', // Durov’s Glasses
    'EQCwEFfUbbR-22fn3VgxUpBil7bwBQqEHm7wgQYbWY9c08YJ', // B-Day Candles
    'EQCZxxFMS-y1hcGADL6EPB7usNstQqD9u-yBaYpXVVMr75NF', // Mini Oscars
    'EQCyAMkb6bNyNlKPH0tJbubk1VVjASqyq9sZwkJ8AbxMkxxU', // Trapped Hearts
    'EQBEngWldzev9oqzctu59Go9afX8HF8HksZ9pJ7x1bRJXsc7', // Liberty Figures
    'EQC2lsUy1SKxJEJBwj5ZCfVnLPvAqDqy5c26Xg8xS_pDTXGk', // Lunar Snakes
    'EQAkqbUwkuFy5sgkgXEGSr9WSxnbslVCc25Ri9BfAEIzXFU-', // Sky Stilettos
    'EQCt2C3yCRNX267B3l6h1QsU6agm4ZgTAb7NpVGiFKlBXOAA', // Genie Lamps
    'EQBD8aBKC4NsnYMqtkCfPQk2EVnieynJQp1UgZVyx1VmR5Ml', // Witch Hats
    'EQDumy3bnZYzV4bSWMSSZkmXqx50XuH5d9RlX_yEi2FNlivk', // Eternal Roses
    'EQDL7HMbca0FufrjHFcRoiLkEiOXkXoO_vH2gVUN8JNp4khK', // Ion Gems
    'EQBV5XozKA0e06Z5y6eL7pWrUUpEolbPhNdcNS0K4ZDk1jCs', // Mood Packs
    'EQADvJxMxCHA7fRlYjoceBORf7RwKs0rzjVaKepQACMnZzG7', // Top Hats
    'EQDQ6DjRabTYSAxf2xrZsnsXtqcIm1bj9dF5x_h8lNjWPmH4', // Evil Eyes
    'EQBw2tO5UaJ4c_YXt3I8y5KD0k37staZxedV2O5HmryiK0dN', // Sharp Tongues
    'EQD6mH9bwbn6S3M_tCRWOvqAIW8M34kRwbI01niGLRPeDPsl', // Spy Agarics
    'EQDycOgkLwcfPDokh8q-2DIUzVhPetdFuZmwrFYFP6i1nZ_u', // Restless Jars
    'EQDsiZuliQn_FTUeyCVaVhojljY7LmimdUtJK1SntGTzff5z', // Khabib’s Papakhas
    'EQC-ZdsouFU-xMa509yP8kzKceZnGV7lSQskxima1Mr3iDYB', // Victory Medals
    'EQA2lHcvZWW_bN_2NMKrkEUv9xz6fx8wTE5upa8u1neZb6hJ', // Lush Bouquets
    'EQD1YFp12AGEgX6C3uiWh751EcRxPZo6GtBmHziY29jcbQzS', // Pool Floats
    'EQCefrjhCD2_7HRIr2lmwt9ZaqeG_tdseBvADC66833kBS3y', // Homemade Cakes
    'EQDeX0F1GDugNjtxkFRihu9ZyFFumBv2jYF5Al1thx2ADDQs', // Mighty Arms
    'EQC8WVW9DSN4PPfFlCW2AHJkXxBUHBFsvnhXiYqSTpD7tXsp', // Winter Wreaths
    'EQDz_VecErEBTLOTiR1tq0VS3lZuHHqhYmhZbthcrbFk7ztK', // Xmas Stockings
    'EQAo_snApDDqF6GKV0xe_T5oe28r842gJtgmkgPMhX0-dRkh', // Whip Cupcakes
    'EQB8zLzEOFQK3qTyMYgPD8BuzmNwblnouqaB80PW-s2E7nct', // Hanging Stars
    'EQBT9PbZBR6FGcZBSnwgo-DLpc0r7_X_8dlhG5UA6v9l9uJM', // Cookie Hearts
    'EQBBLRFtC_3PLxNpWX5nfchwapk7eWcG3dzKoxbV6cWzqROo', // Pet Snakes
    'EQCMBgeRNOjZo6A_GpF4G66VTA8V4vpSitIZzJP3Qz4ZO5YM', // Bonded Rings
    'EQAOYYJib8K6-91TjeOYRbWEtbtRJHXKoWltnULwdaqd7mR5', // Electric Skulls
    'EQAwzubeoJwnqmmBuTPpnUSurRzWPB8ERzcfzx55Z2YjE0jx', // Jelly Bunnies
    'EQDLM65t0shS7gZAg0lMltGHYhsU94PzsMJHhYibmRV7kdUs', // Candy Canes
    'EQCBK_JBASAA5XVz1D17Pn--kQaMWm0b9wReVtsEdRO4Tgy9', // Jester Hats
    'EQAtgbhSHOqTxjuRLLOAab6T66FPcQWTNd_DT3VgCG1-tHJw', // Crystal Balls
    'EQAPNu648fe_uqUoeH6V_-fIDJYea_5Xu2rXn6iZFil49bMY', // Snow Globes
    'EQDr4xn5_GoCzDxhGJMek7fv3nm6W7bhRvlDSBjcNZul52tZ', // Record Players
    'EQC7oPa-gJDZ6JRwW0WW4WH_Vjn7ioKmfDdFItD7nYFGdbuU', // Moon Pendants
    'EQD7yDu2WCgd9Uzx1dF_DQkWK7IZJJ4Mp9M9g1rGUUiQE43m', // Love Potions
    'EQAtFU9GrGfix4UG9DOivN58QxvgBJUaAZ_pdZBZCmbhKo4P', // Magic Potions
    'EQD9z87hRZAV7C2MV1gk39-bSg5Yfs2EdMr9HfK81IuB2Rlc', // Faith Amulets
    'EQDx-SqQEhP9Rzfi2cqdehTVUvQbArsUz1X7t-ul8IiKZpYb', // Big Years
    'EQA3-i1IUFjWyDhaIoCGdYUB4nt2IYaT3T-95CHPrSvV3AfX', // Bunny Muffins
    'EQAUffQWl09_yhXDTp8oN13Px8ygPm0xcyNGhHOiONV-x3om', // Fresh Socks
    'EQBdlKhLzezYFMCWSWTCnhpKC1uyczaBUOj3EtPjcatUsTrC', // Mad Pumpkins
    'EQA_kx2WOydXWzYUYO1DP80aHl4yhlLGYhxjPAtRPNjMgfYM', // Tama Gadgets
    'EQC212djrq0gglQXi8MSFX1bcw4LHw3Es62lKvt1lZzzsYuF', // Timeless Books
    'EQBzZLNIr4lie0pTfrbRsANJOtFYwY5gmngRfs84Ras5-aVN', // Eternal Candles
    'EQBM3U1twWjI_vYUaPdFkzZs1q9c0orHhQjx0m2Xa9ljgTqY', // Money Pots
    'EQB1ATaKGNYk6T5R2cA18BOF-KB_idaKKigwYI2jtjWuLg8n', // Happy Brownies
    'EQCehrkZtKDtVe0qyvBAsrHx3hW-hroQyDrS_MZOOVYth2DG', // Jingle Bells
    'EQBbUKx5CalEly2TekDNeFbv4e02pj6xsAqXZP0X_AprKj4I', // Snake Boxes
    'EQDpxJ6VAwUA-tX6w8ACnoAJLrP3hKWmieBl71uv1_qKRD3x', // Bow Ties
    'EQA8DCWyCWyywgOKYORerRoSVevWrUQ_FjKQgNihxY1227x7', // Spiced Wines
    'EQARIAumGWBmKSv2BoMxtunCEFybIn6nimCq_laeqkD-AVSk', // Bling Binkies
    'EQB6AtBPOuTtQml8oSA7X8ZqJ5QmcOYYqoz92sQYXGUQrxyB', // Hex Pots
    'EQCBcMPpEjKJysTb534Nvt3FXQgkzVyhaaBDIyrcaKD1PsFF', // Joyful Bundles
    'EQA401QqpXtBnwIaDbFjwd5yXfP2mYiCusbJ3Zcw9eXR9CqL', // Jacks-in-the-Box
    'EQC65Yy6N04vHoeCJ0yo4qll5eu-ZaWbS5nxsdilxymhmSus', // Hypno Lollipops
    'EQA0EzRYX5wm_q46_NX8b7EYhtOkXfXgsr06ETbov1a7StZl', // Pretty Posies
    'EQBG2o0lp-6Oy86NGEJm717BeTDAw_F5ELkgaX2l9UsfavWE', // Flying Brooms
    'EQBAXR68f1UgRhToFR_bXY1zPJy5O6sm2St0CRTo92BTxGiH', // Star Notepads
    'EQAaTIR7oJyowDiumYLVN0oe61kGE3I6EPEn7WgHPGuWAeCy', // Santa Hats
    'EQBaOL8mH5YywkXjkps65X1OLPNH7pns4YcfLmaVpFaoNKZn', // Skull Flowers
    'EQDqHwSzU4I_U44vSM9EDP4HGGKWy9yWjbzkpCa3K8iMBEVD', // Love Candles
    'EQDLda715GocP1sYDkCecPhO7eFNsNvARD4pumbGSan96wvZ', // Surge Boards
    'EQBCwFnalN0aGzoJgVihtMLTeXuKO_tHIxq7bddNlnH2JoVB', // Fine Pens
    'EQCEVLBbgzL5Ih9bzMkneLi68xzOelYN3NEugm_4gZTpuAFP', // Ionic Dryers
    'EQB4x3sT1DVdODzay3H-4VJIdOooS5-kTgyKcYMZWogPOsiq', // Berry Boxes
    'EQDjBdu3zS-JT94OwIup4KVNaQjxDzGcIPRJ24Ha0Y8jLw83', // Valentine Boxes
    'EQBjzdi27ZI-Re93OOIia0m7YmUU8d8ubJNsStZTc7qNJnOv', // Mousse Cakes
    'EQB5P3ZP2PjLION52Y1SNAux1do4-ZOqMWotXS-fdMpqHcCH', // Holiday Drinks
    'EQBcNxMCTyEHkcQ5cK3fO_3Ebjf6JcA5JJ_OJV4npDN-604P', // Sleigh Bells
    'EQAIM-5QzZGXYTSZR1RGeT2g9rNpYmNPQ09_HtvaInHaTyPX', // Snow Mittens
]);

const OTHER_COLLECTIONS = new Set([
    'EQCA14o1-VWhS2efqoh_9M1b_A9DtKTuoqfmkn83AbJzwnPi', // Telegram Usernames
    'EQAOQdwdw8kGftJCSFgOErM1mBjYPe4DBPq8-AhF6vr9si5N', // Anonymous Telegram Numbers
    'EQC3dNlesgVD8YbAazcauIrXBPfiVhMMr5YYk2in0Mtsz0Bz', // TON DNS Domains
    'EQAic3zPce496ukFDhbco28FVsKKl2WUX_iJwaL87CBxSiLQ', // Gram DNS
    'EQBWG4EBbPDv4Xj7xlPwzxd7hSyHMzwwLB5O6rY-0BBeaixS', // VIP TON DNS Domains

    'EQCvYf5W36a0zQrS_wc6PMKg6JnyTcFU56NPx1PrAW63qpvt', // Rich Cats
    'EQDGNvj3jV6_gWhpp9Z5DLokRIITPNuDP7TzHZ-vp1p4n5DU', // Outfits
    'EQDOGEYi39CnE88MVASzshStaF-lKjEKBHwDsjQESK6sJHpA', // Piercing
    'EQDHHWWfhhf0uQQfVscSvm8gl30TLY-mAUo2N63-btNdIXxE', // Glasses
    'EQDrPbUy2fJDjtZF3hN1dxnQqdHyJ6AYwSxwDvs4L4vbVYcJ', // Hats
    'EQCQE2L9hfwx1V8sgmF9keraHx1rNK9VmgR1ctVvINBGykyM', // My Wallet Cards
    'EQAo92DYMokxghKcq-CkCGSk_MgXY5Fo1SPW20gkvZl75iCN', // TON Punks 💎
    'EQCl7vtRvsU6J4fcVKU9GIfz_z-zvP-ouwh8l2HjgRpPWE6-', // TinyVerse
    'EQA2glKDbvezR0KZstAqNmHLEpkOHId1RYAGwza06XLCOLTl', // Gatto | Official NFT storage
    'EQAG2BH0JlmFkbMrLEnyn2bIITaOSssd4WdisE4BdFMkZbir', // TON Diamonds
    'EQB6SewXbKZujsOt3W8O-vqtbvGXxs3N2M5kqQC70pjYzUdf', // Ducky Gods - DUCK × MY × DUCK
    'EQA5HalN4asamSjufbmXF_Wr3jyapCEYcYN0igfBDe5Nmbm7', // NOT Wise
    'EQBaaILVmMrfDycKEd8b-6pQtZVio5UnQLh_3elW-6YaT6ZH', // Major Achievements
    'EQDHm0Iymo6Jheo7cpB15LQzM7nKQdgGHqGhJQEsLCHB_E0R', // CITY Holder | NFT lands
    'EQDPcCeltOvzIsxKWWwf08gUoGPh37ZzOSxKqhAPWTQi-VQc', // TON Email Names
    'EQCzuSjkgUND61l7gIH3NvVWNtZ0RX1hxz1rWnmJqGPmZh7S', // Toned Ape Club!
    'EQD9PN7ewQMj022Am0MIgtYGmaUR4wsnz7WhwyMNwz4gQmy0', // Degenphone
    'EQDzNbnM5DpdXMERlvzFT2yhAPtmnoyqSFPpWlrkJwV-g7xP', // Teddie Nakamoto
    'EQAC78pGQ9IDzmhL28uFoae-xGSJmJukTIcatQPAlxHFtWW5', // Teddie: Goodies Intern
    'EQDyWZIoTXuEUaM6ROtnKs0lmtkJVWEg1vXMimm_A_rdMIyE', // Welcome to TON
    'EQAzlVUwnQKBSJeyyP-733Xp44tnZDg_b_dzMqZEO-z58yeC', // Povel Durev
    'EQAA1yvDaDwEK5vHGOXRdtS2MbOVd1-TNy01L1S_t2HF4oLu', // Animals Red List
    'EQC9fhHpKKutCbfg9r9W3KW_L_pMMjZAW8He1Bqpq-phwXZK', // Lobsters
    'EQCGYlzlIXsUs9lm3LdMcqHicSyl_5QDEn6QR3xdRcjW698K', // Povel Durev #2
    'EQDahyr_gPkHBPbhyrvjoHGVFGGj8vXXtL7w14AV3S2JvpTF', // TON Frogs
    'EQDgZmQpDJbO6laHvvibaXYXMlEAYEH6LnUtA5J19W18dENp', // G-BOTS SD
    'EQA-6lNbJCoOt4s3fKL7lhQCX2IndvCDY5BnrOIbqOJl5VSo', // Teddie Ultimate
    'EQBpBsShOF1EvuX3nOKwNuzr5YWlJjdpCH_2n8ybizF479Tg', // Fanton Fantasy Football
    'EQAv34EhRpc6hSzYpysGYVWbnmKhOtl3C8m2aeXsO-wiXhD3', // Raff Club NFT Pass
    'EQB8D8A9OoDoRmL7qVbUBrd_po9vNKcl44HCSw6b-c3nvcj9', // Annihilation
    'EQB3Pd1e7fs89vw6wwlDzS-CrdvDY8phfdn7yKgvL6UQn6ij', // NUTCRACKERS
    'EQB_oI5-DE8iAXC3D8rGvXFeCWLNWG6Uc6_tw3Ocs_Ck14-u', // Not Meme
    'EQBFELwdddZzNFXhiZxE1i_4700KG7XmiDTLYzO7UJI-YuRk', // NOT Wise Eggs
    'EQAzkaVZCp62HBz8KveKM0n_ju8Z2TTbDKHrEipSEVvXJ58Z', // Mintosaurs
    'EQAmTVtgzf14BiZSvDFQgA3vY7Isey8sHB3nAtZQS-2Vs2hw', // Groyper
]);

// Collection addresses reach us in both EQ… and UQ… flavours, so the lookups
// compare the base64 hash part only, the same way isSameAddress() does.
const hashPart = address => address?.substring(1, 44);
const hashesOf = collections => new Set([...collections].map(hashPart));

const GIFT_HASHES = hashesOf(TELEGRAM_GIFT_COLLECTIONS);
const WHITELIST_HASHES = new Set([...GIFT_HASHES, ...hashesOf(OTHER_COLLECTIONS)]);

/**
 * @param  {String|null|undefined} collectionAddress
 * @return {Boolean}
 */
export const isTelegramGiftCollection = collectionAddress => GIFT_HASHES.has(hashPart(collectionAddress));

/**
 * @param  {String|null|undefined} collectionAddress
 * @return {Boolean}
 */
export const isWhitelistedCollection = collectionAddress => WHITELIST_HASHES.has(hashPart(collectionAddress));
